//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isFunction } from '@/utils/validator'
import CIcon from '../CIcon'
import {
  cloneDeep,
  dig,
} from '../../utils/lodash'
import { filterByLabelFormat } from '../../utils/translate'

export default {
  name: 'CSmartTree',

  components: { CIcon },

  props: {
    apiMethod: { type: Function },

    value: {
      type: [
        String,
        Number,
      ],
      default: '',
    },

    valueName: {
      type: String,
      default: 'key',
    },

    dataPath: {
      type: String,
      default: 'data',
    },

    remoteMethod: { type: Function },

    remoteParams: {
      type: Object,
      default: () => ({ dictCode: 'xzqh' }),
    },

    postMethod: { type: Function },

    methodConfig: {
      type: Object,
      default: () => ({}),
    },

    dynamicLoadMethod: { type: Function },

    dynamicLoadParams: {
      type: Object,
      default: () => ({ dictCode: 'xzqh' }),
    },

    data: {
      type: Array,
      default: () => ([]),
    },

    canSelectParent: {
      type: Boolean,
      default: false,
    },

    labelFormat: {
      type: String,
      default: '{label}',
    },

    totalPath: {
      type: String,

      default: 'data.total',
    },

    dataHook: { type: Function },

    loadingText: {
      type: String,

      default: '加载中',
    },

    params: {
      type: Object,
      default: () => ({
        dictCode: 'xzqh',
        level: 1,
      }),
    },
  },

  data () {
    return {
      treeList: [],
      levelTreeList: [],
      treeLocalTreeList: {},
      selected: [],
      innerValue: '',
      loadingFlag: false,
    }
  },

  computed: {
    hasDynamicLoadMethod () {
      return isFunction(this.dynamicLoadMethod)
    },
  },

  watch: {
    value: {
      handler: 'onWatchValueChange',
      deep: true,
      immediate: true,
    },

    innerValue: {
      handler (val, old) {
        if (old !== undefined) {
          this.$emit('input', val)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    filterHasSelectedByBranch (branch) {
      const data = this.selected.filter((el) => `${el.value}` === `${branch.value}`) || []

      return data.length > 0
    },

    onWatchValueChange (val, oldVal) {
      if (this.treeLocalTreeList[val] && this.filterHasSelectedByBranch({ value: val })) { // 缓存数据有值的时候
        this.treeList = this.treeLocalTreeList[val]
      } else if (oldVal === undefined && val) {
        this.initSetTreeLevelData(val, oldVal)
      }
    },

    reload () {
      this.initSetTreeLevelData(this.value)
    },

    clearLevelData (branch) {
      const { level, value } = branch
      const index = level - 1

      if (value !== this.selected[index]?.value) {
        this.selected.splice(index)

        this.levelTreeList.splice(index)
      }
    },

    async handlerClickBranchByParent (branch) {
      const { level, value } = branch
      const index = level - 1

      this.clearLevelData(branch)

      this.selected[index] = branch
      this.levelTreeList[index] = this.treeList

      const data = await this.getChildrenData(branch)

      this.$emit('on-select', {
        branch,
        selected: this.selected,
        tree: this.treeList,
        all: this.treeLocalTreeList,
      })

      if (this.canSelectParent) {
        this.innerValue = value
      } else {
        if (!data?.length || !branch.hasChild) {
          this.innerValue = value
        }
      }

      if (!data?.length || !branch.hasChild) {
        return
      }

      this.treeList = data
      this.treeLocalTreeList[branch.value] = this.treeList
    },

    async showCurrentLevelData (branch) {
      this.setCurrentLevelData(branch)
    },

    async initSetTreeLevelData (value) {
      let currentValueParent = {}

      if (this.remoteMethod && value) {
        this.loadingFlag = true

        // remoteMethod只能得到当前value的各层父子节点数据
        const { data } = await this.remoteMethod({
          ...this.remoteParams,
          childrenWid: value,
        }, this.methodConfig, this.postMethod)

        this.loadingFlag = false
        const result = await this.getPath([data], value)

        this.selected = result.map((el, index) => {
          return {
            ...el,
            name: el.label,
            wid: el.value,
            hasChild: index !== result?.length - 1,
          }
        })

        const selectLength = this.selected?.length
        currentValueParent = selectLength > 1 ? this.selected[selectLength - 2] : []
      } else {
        this.selected = []
      }

      await this.setTreeList(currentValueParent)

      this.$emit('init', {
        branch: currentValueParent,
        selected: this.selected,
        tree: this.treeList,
        all: this.treeLocalTreeList,
      })
    },

    getPath (data = [], value, path = '') {
      let hkszdCode = []

      function getTreePath (data = [], value, path = []) {
        data.forEach((el, index) => {
          if ((`${el.value}`) === (`${value}`)) {
            path.push(el)
            hkszdCode = path
          } else if (el.children) {
            getTreePath(el.children, value, path.concat(el))
          }
        })
      }

      getTreePath(data, value)

      return hkszdCode
    },

    async setTreeList (parent = {}) { // 初始化查询，可以支持apiMethod/this.data/远程dynamicMethod
      const { level, value } = parent

      if (this.hasDynamicLoadMethod) {
        this.treeList = await this.getDynamicData(parent)
        this.levelTreeList[level || 0] = cloneDeep(this.treeList)
      } else {
        if (this.apiMethod) {
          this.levelTreeList = await this.getTreeData(this.apiMethod, this.params)
        } else {
          this.levelTreeList = this.data
        }

        this.treeList = this.levelTreeList[0]
      }

      if (value) {
        this.treeLocalTreeList[value] = this.treeList
      }
    },

    async getTreeData (action, params) {
      this.loadingFlag = true
      const result = await action(params, this.methodConfig, this.postMethod)

      let data = dig(result, this.dataPath) || []

      if (this.dataHook) {
        data = this.dataHook(data || [])
      } else {
        data = this.filterData(data || [])
      }

      this.loadingFlag = false

      return data
    },

    async getDynamicData (parent = {}) {
      const { value } = parent

      if (this.treeLocalTreeList[value]?.length) {
        return this.treeLocalTreeList[value]
      }

      const result = await this.getTreeData(this.dynamicLoadMethod, {
        parentWid: parent?.wid,
        ...this.dynamicLoadParams,
        level: parent?.level ? parent?.level + 1 : 1,
      })

      return result
    },

    async setCurrentLevelData (current) {
      const { level } = current
      const index = level - 1
      const treeData = this.levelTreeList[index]

      if (!treeData?.length) { // 如果当前级无数据，去查询数据
        this.setTreeList(index > 0 ? this.selected[index - 1] : {})
      } else {
        this.treeList = treeData
      }
    },

    async getChildrenData (parent = {}) {
      let data = []

      if (this.hasDynamicLoadMethod && parent.hasChild) {
        data = await this.getDynamicData(parent)
      } else {
        data = parent?.children || []
      }

      return data
    },

    filterData (data) {
      const filterResult = data?.map((el) => {
        return {
          active: false,
          ...el,
          value: el[this.valueName],
          name: filterByLabelFormat(el, this.labelFormat),
          hasChild: el.hasChild,
          parentWid: el.parentWid,
        }
      })

      return filterResult
    },
  },
}
